import React, { useCallback } from 'react';
import { useTranslation } from '@hooks/useTranslation';

const ModeToggleButton = ({ mode, onToggle, disabled }) => {
  const { t } = useTranslation();

  const toggleMode = useCallback(() => {
    onToggle(prev => prev === 'wheel' ? 'input' : 'wheel');
  }, [onToggle]);

  const modeIcon = mode === 'wheel' ? '⌨️' : '🎡';
  const modeTitle = mode === 'wheel'
    ? t('common.switch_to_input_mode')
    : t('common.switch_to_wheel_mode');

  return (
    <button
      type="button"
      className="integer-input__toggle"
      onClick={toggleMode}
      disabled={disabled}
      title={modeTitle}
    >
      {modeIcon}
    </button>
  );
};

export default ModeToggleButton;
